
import Grammerly from "../../../assets/filled/Grammerly.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GrammerlyIcon({ className, dataTestid = "GrammerlyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Grammerly data-testid={dataTestid} className={classes} {...rest} />
  );
}
